import * as React from 'react'

type Load = [boolean, () => void]

export function useListLoadingIndicator(elementToWatch: number | undefined): Load {
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    setIsLoading(false)
  }, [elementToWatch])

  return [isLoading, () => setIsLoading(true)]
}
